module.exports = __webpack_public_path__ + "static/media/example3.0187b57d.jpg";